"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M16.01 11H4v2h12.01v3L20 12l-3.99-4z"
}), 'ArrowRightAlt');